import type { HoldersAction } from './actions';
import type { HolderSortColumn, SortDirection, HoldersState } from './types';

const DEFAULT_DESC_COLUMNS = new Set<HolderSortColumn>([
    'rank',
    'shares',
    'value',
    'ownershipPct',
    'floatPct',
    'changeShares',
    'changePct',
]);

function defaultDirection(column: HolderSortColumn): SortDirection {
    return DEFAULT_DESC_COLUMNS.has(column) ? 'desc' : 'asc';
}

function nextDirection(current: SortDirection): SortDirection {
    return current === 'asc' ? 'desc' : 'asc';
}

export function reducer(state: HoldersState, action: HoldersAction): HoldersState {
    switch (action.type) {
        case 'SET_PERIOD':
            if (state.periodId === action.periodId) return state;
            return { ...state, periodId: action.periodId };
        case 'SET_FILTER':
            if (state.filter === action.filter) return state;
            return { ...state, filter: action.filter };
        case 'SET_SEARCH': {
            const search = action.search.trimStart();
            if (state.search === search) return state;
            return { ...state, search };
        }
        case 'SET_SORT':
            if (state.sortColumn === action.column) {
                return { ...state, sortDirection: nextDirection(state.sortDirection) };
            }
            return { ...state, sortColumn: action.column, sortDirection: defaultDirection(action.column) };
        default: {
            const _exhaustiveCheck: never = action;
            return state;
        }
    }
}
